import React from 'react';
import { ProductFormManager } from '../event-fields/ProductFormManager';

/**
 * Event Products Tab Component
 * Handles products/tickets management
 */
export const EventProductsTab = ({ eventType, isEdit = false, record = {} }) => {
  return <ProductFormManager eventType={eventType} disabled={isEdit} isEdit={isEdit} record={record} />;
};
